module.exports = __webpack_public_path__ + "img/Engagement_Under_Engaged_32.d113d34e.png";